import { render, staticRenderFns } from "./input-staff.vue?vue&type=template&id=8a502fe6&scoped=true"
import script from "./input-staff.vue?vue&type=script&lang=js"
export * from "./input-staff.vue?vue&type=script&lang=js"
import style0 from "./input-staff.vue?vue&type=style&index=0&id=8a502fe6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a502fe6",
  null
  
)

export default component.exports